import { useQuery } from 'react-query';
import { getPaymentsNew } from '../../api/payments-api';
import { queryKeys } from '../../services/query-key/query-keys';

type UsePaymentsNewParams = {
  page: number;
  pageSize: number;
  search?: string;
  paymentFilters?: string;
  sort?: string;
};

export const usePaymentsNew = (params: UsePaymentsNewParams) => {
  return useQuery({
    queryKey: queryKeys.paymentsNew(...Object.values(params)),
    queryFn: () => getPaymentsNew(params),
    keepPreviousData: true,
  });
};